export default "__VITE_ASSET__CWdSRykm__"